import styled from 'styled-components'
import { mq } from '@styles/vars/media-queries.style'

export const GridMain = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-left: -15px;
  margin-right: -15px;
`
export const Item = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 30px 0;
  width: calc(100% / 2);

  ${mq.tabletP} {
    width: calc(100% / 3);
  }

  ${mq.tabletL} {
    width: calc(100% / 4);
  }
`